const ListTable = require('app/ui/list/Table');
const IFrame = require('app/ui/modal/IFrame');
const GraphQLMutation = require('app/graphql/Mutation');

class BillingView {
	defaultOptions() {
		return {
			'selector': '.view-order-list',
			'tableContainerSelector': '.order-list-container',
			'filterFormSelector': '.order-list-search-form',
		};
	}

	constructor(options) {
		this.settings = $.extend(this.defaultOptions(), options);


		this.buildGraphQLParameters = this.buildGraphQLParameters.bind(this);
		this.onSubmitFilterForm = this.onSubmitFilterForm.bind(this);
		this.buildFooter = this.buildFooter.bind(this);

		this.$container = $(this.settings.selector);
		if(this.$container.length <= 0){
			window.notify("Can't find container view with selector " + this.settings.selector,'danger');
		}

		this.$tableContainer = $(this.settings.tableContainerSelector,this.$container);
		this.$filterForm =  $(this.settings.filterFormSelector,this.$container);

		this.initialize();
	}

	initialize() {
		var self = this;
		
		this.initializeFilterForm();
		this.initializeListTable();
		this.initializeControlClick();
	
	}

	initializeControlClick(){
        $('body').on('click','.btn-control-delivery',function(){
            let $btn = $(this);
            let modal = new IFrame({
				'modalSize': 'full',
                'url': '/order/delivery/' + $btn.data('orderid') + '/show/',
            });

            modal.show();
			
			return false;
		});
	}

	initializeFilterForm(){
		var self = this;



        this.$filterByID = $('input[name="order_id"]',this.$filterForm);
        this.$filterByID.on('change',this.onSubmitFilterForm);
		
        this.$filterByBL = $('input[name="bl"]',this.$filterForm);
        this.$filterByBL.on('change',this.onSubmitFilterForm);

        this.$filterByBLSupplier = $('input[name="blSupplier"]',this.$filterForm);
        this.$filterByBLSupplier.on('change',this.onSubmitFilterForm);
		
		this.$filterByRestaurant = $('select[name="restaurant"]',this.$filterForm);
		this.$filterByRestaurant.on('change',this.onSubmitFilterForm);
		this.$filterByRestaurant.select2();

		this.$filterForm.on('submit',this.onSubmitFilterForm);

	}

	onSubmitFilterForm(event){
		event.preventDefault()
		event.stopPropagation();

		this.table.refresh();
	}

	reload(){
		this.table.refresh();
	}

	initializeListTable(){
		var self = this;

		let fields = [
			'id',
			'restaurantName',
			'supplier { id name }',
			'deliveryNumber',
			'deliveryNumber2',
			'invoicePendingDate',
			'total',
			'totalTTC',
			'createdAt',
			'netSale'
		];

		this.table = new ListTable({
			'$container': this.$tableContainer,
			'tableClass': 'table table-striped order-list',
			'id': 'list-orders',
			'length': 1000,
			'graphQL': {
				'queryType': 'restaurantOrders',
				'fields': fields,
				'parameters': this.buildGraphQLParameters,

			},
            'showPagination': false,
            'footerBuilder': {
                'mode': 'custom',
                'render': this.buildFooter,
            },
			'columns': [
				{
					'name': 'id',
					'label': window.translate('restaurant.order.id.label'),
					'class': 'order-id',
					'render': function(item,index){
						let $checkbox = $('<input/>')
						.attr('type','checkbox')
						.attr('name', 'selection[]')
						.attr('data-supplier',item.node.supplier.id)
						.attr('checked','checked')
						.val(item.node.id)
						.on("change",function(event){
							self.refreshTotal();
						});

						let $content = $('<div/>')
						.append($checkbox)
						.append(' ')
						.append(item.node.id);
						return $content;
					},
				},
				{
					'name': 'createdAt',
					'label': window.translate('restaurant.order.createdAt.label'),
					'class': 'order-date',
					'ordered': true,
					'orderType': 'createdAt',
					'orderDir': 'DESC',
					'render': function(item,index){
						return window.formatDate(item.node.createdAt,window.translate('momentDateFormat.fullDay'));
					},
				},
				{
					'name': 'restaurant',
					'label': window.translate('restaurant.order.restaurant.label'),
					'class': 'order-restaurant',
					'render': function(item,index){
						let $content = $('<div/>')
						.append(item.node.restaurantName)

						if(item.node.invoicePendingDate){
							let dateLabel = window.formatDate(item.node.invoicePendingDate,window.translate('momentDateFormat.fullDay'));
							$content.append(
								$('<div/>')
								.addClass('text-danger')
								.append(window.translate('billing.invoicePending.date.label') + ' ' + dateLabel)
							)
						}
						return $content;
					},
				},
				{
					'name': 'supplier',
					'label': window.translate('restaurant.order.supplier.label'),
					'class': 'order-supplier',
					'render': function(item,index){
						return item.node.supplier.name;
					},
				},
				{
					'name': 'deliveryNumber',
					'label': window.translate('restaurant.order.deliveryNumber.label'),
					'class': 'order-deliveryNumber',
					'render': function(item,index){
						return item.node.deliveryNumber;
					},
				},
				{
					'name': 'deliveryNumber2',
					'label': window.translate('restaurant.order.deliveryNumber2.label'),
					'class': 'order-deliveryNumber2',
					'render': function(item,index){
						return item.node.deliveryNumber2 == 0 ? '/' : item.node.deliveryNumber2;
					},
				},
				{
					'name': 'total',
					'label': window.translate('total'),
					'class': 'order-total',
					'render': function(item,index){
						return window.formatFloat(item.node.netSale) + ' &euro;';
					},
				},
				{
					'name': 'actions',
					'label': '',
					'class': 'order-actions',
					'render': function(item,index){
						let $list = $('<ul/>')
						.addClass('list-inline btn-list-inline');

						// Ouverture d'une fancybox avec le détail de la commande
						let $btnShow = $('<a/>')
						.attr('href',"#")
						.addClass('btn btn-link text-primary btn-order-show')
						.attr('data-orderid',item.node.id)
						.attr('title',window.translate('restaurant.order.actions.show.label'))
						.append(
							$('<i/>')
							.addClass('fa fa-search')
						);

						// Contrôle des livraisons
						let $btnControl = $('<a/>')
						.attr('href',"#")
						.addClass('btn btn-link text-primary btn-control-delivery')
						.attr('data-orderid',item.node.id)
						.attr('title','Contrôler la commande')
						.append(
							$('<i/>')
							.addClass('fa fa-clipboard-list')
						);

						$list.append(
							$('<li/>')
							.addClass('list-inline-item')
							.append($btnShow)
							.append($btnControl)
						);

						//@todo rest of buttons

						return $list;
					},
				},

			]
		})
	}

	buildGraphQLParameters(){

		let filters = {
			"status" : 1,
			"verified" : true,
			"billed": false,
			"supplierCanBill": true,
			"restaurantParticulier" : 0,
			"restaurantOnly": true,
			"notIdIn": [592]
		};

		if(this.$filterByRestaurant && this.$filterByRestaurant.val()){
			filters.restaurant = parseInt(this.$filterByRestaurant.val());
		}

		if(this.$filterByID && this.$filterByID.val()){
			filters.id = parseInt(this.$filterByID.val());
		}

		if(this.$filterByBL && this.$filterByBL.val()){
			filters.deliveryNumber = this.$filterByBL.val();
		}

		if(this.$filterByBLSupplier && this.$filterByBLSupplier.val()){
			filters.deliveryNumber2 = this.$filterByBLSupplier.val();
		}
		

		let parameters = {
			'orderBy' : "createdAt",
			'filter' : filters
		};

		return parameters;
	}

    buildFooter(data){
    	var self = this;
        let $row = $('<tr/>');

        this.items = data;
        this.$totalContainer = $('<div/>');

        this.$inputDate = $('<input/>')
        .attr('type',"date")
        .addClass('form-control')
        .attr('name','date')
        //.attr('min',moment().format('YYYY-MM-DD'))
        .val(moment().format('YYYY-MM-DD'));

        this.$formSubmit = $('<form/>')
        .addClass('mt-2')
        .hide()
        .append(
        	$('<div/>')
        	.addClass('form-group')
        	.append(
        		$('<label/>')
        		.attr('for','date')
        		.append(window.translate("billing.invoicePending.date.label"))
    		)
    		.append(this.$inputDate)
    	)
    	.append(
    		$('<div/>')
    		.addClass('d-flex justify-content-center p-2')
    		.append(
	    		$('<button/>')
	    		.attr('type','submit')
	    		.addClass('btn btn-success')
	    		.append(window.translate('app.order.billing.submit.label'))
	    	)
		)
		.on("submit",function(event){
			event.preventDefault();
			event.stopPropagation();

			self.doSubmit();
		})


        $row
        .append(
            $('<td/>')
            .attr('colspan',3)
            .append(this.$totalContainer)
        )
        .append(
            $('<td/>')
            .append("&nbsp;")
        )
        .append(
            $('<td/>')
            .append("&nbsp;")
        )
        .append(
            $('<td/>')
            .attr('colspan',2)
            .append(this.$formSubmit)
        )
        .append(
            $('<td/>')
            .append("&nbsp;")
        )

        this.refreshTotal();

        return $row;
    }


    refreshTotal(){
    	$('.summary',this.$totalContainer).remove();
		let data = this.items;

        if(data.length <= 0){
            return '';
        }

        let total = 0;
        let totalBySupplier = {};

        let selection = [];

        for(var i in data){
            let item = data[i].node;
            let $checkbox = $('input[name="selection[]"][value="'+item.id+'"');
            let itemTotal = parseFloat(item.netSale);

            if($checkbox.is(':checked')){
            	selection.push(item.id);

            	total += itemTotal;
	            let supplier = item.supplier;
	            if(!totalBySupplier[supplier.id]){
	            	totalBySupplier[supplier.id] = {
	            		'name': supplier.name,
	            		'total': 0,
	            	};
	            }
	            totalBySupplier[supplier.id].total+=itemTotal;
	        }
        }

        this.selection = selection;

        let $total = $('<ul/>')
        .addClass('summary')
        .addClass('list-unstyled');

        $total
        .append(
        	$('<li/>')
        	.addClass('text-bold')
        	.append(window.translate('totalToBill'))
        	.append(
	        	$('<span/>')
	        	.addClass('float-end')
	        	.append(window.formatFloat(total) + ' &euro;')
	        )
    	)

    	let supplierIds = Object.keys(totalBySupplier);
    	for(var i in supplierIds){
    		let supplierId = supplierIds[i];
    		let supplier = totalBySupplier[supplierId];
    		if(supplier.total){
		        $total
		        .append(
		        	$('<li/>')
		        	.append(supplier.name)
		        	.append(
			        	$('<span/>')
			        	.addClass('float-end')
			        	.append(window.formatFloat(supplier.total) + ' &euro;')
			        )
		    	)	
		    }
    	}

    	this.$totalContainer.prepend($total);

    	if(this.selection.length > 0){
    		this.$formSubmit.show();
    	}else{
    		this.$formSubmit.hide();
    	}

    }

    doSubmit(){
        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'orders': {
                'value': this.selection,
                'type': '[Int]',
            },
            'date':{
            	'value': this.$inputDate.val(),
            	'type': "String!"
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "GenerateInvoices",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                window.notify(data.message,'success');
                self.reload();
            },
            'error': function(message, xhr){
                window.notify(message,"error");
            },
            'after': function(){
                //do nothing
            }
        });
        mutation.execute();
    }
}

module.exports = BillingView;